// API
import { get } from "../../../services/api";

export const CLEAR_ADMIN_USERS = "CLEAR_ADMIN_USERS";
export const CLEAR_LOADING = "CLEAR_LOADING";
export const CLEAR_SELECTED_CANDIDATE = "CLEAR_SELECTED_CANDIDATE";
export const SET_ADMIN_USERS_SUCCESS = "SET_ADMIN_USERS_SUCCESS";
export const SET_ADMIN_USERS_ERROR = "SET_ADMIN_USERS_ERROR";
export const SET_LOADING = "SET_LOADING";
export const SET_SELECTED_CANDIDATE = "SET_SELECTED_CANDIDATE";
export const GET_ADMIN_USERS_NEXT_PAGE_SUCCESS = "GET_ADMIN_USERS_NEXT_PAGE_SUCCESS";

const defaultState = {
  count: 0,
  error: false,
  loading: false,
  selectedCandidate: undefined,
  users: [],
  trainingProviders: []
};

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case CLEAR_ADMIN_USERS:
      return {
        ...state,
        users: defaultState.users,
        count: defaultState.count,
        trainingProviders: defaultState.trainingProviders
      };
    case CLEAR_SELECTED_CANDIDATE:
      return { ...state, selectedCandidate: undefined };
    case CLEAR_LOADING:
      return { ...state, loading: false };
    case SET_ADMIN_USERS_ERROR:
      return { ...state, error: payload };
    case SET_ADMIN_USERS_SUCCESS:
      return {
        ...state,
        users: payload.results,
        count: payload.count,
        trainingProviders: payload.trainingProviders
      };
    case SET_SELECTED_CANDIDATE:
      return { ...state, selectedCandidate: payload };
    case SET_LOADING:
      return { ...state, loading: true };
    case GET_ADMIN_USERS_NEXT_PAGE_SUCCESS:
      return { ...state, users: [...state.users, ...payload.results] };

    default:
      return state;
  }
};

export const clearAdminUsers = () => ({
  type: CLEAR_ADMIN_USERS
});

export const clearLoading = () => ({
  type: CLEAR_LOADING
});

export const clearSelectedCandidate = () => ({
  type: CLEAR_SELECTED_CANDIDATE
});

export const setAdminUsersSuccess = (payload) => ({
  type: SET_ADMIN_USERS_SUCCESS,
  payload
});

export const setAdminUsersError = (payload) => ({
  type: SET_ADMIN_USERS_ERROR,
  payload
});

export const setLoading = () => ({
  type: SET_LOADING
});

export const setSelectedCandidate = (payload) => ({
  type: SET_SELECTED_CANDIDATE,
  payload
});

export const getAdminUsersNextPageSuccess = (payload) => ({
  type: GET_ADMIN_USERS_NEXT_PAGE_SUCCESS,
  payload
});

export const getAdminUsers = ({
  offset = 0,
  orderBy,
  pageSize = 10,
  q,
  sort,
  trainingProvider
}) => {
  const params = {
    offset,
    pageSize,
    ...(q && { q }),
    ...(orderBy && { orderBy }),
    ...(sort && { sort }),
    ...(trainingProvider && { trainingProvider })
  };

  const url = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");

  return async (dispatch) => {
    try {
      // if the offset is zero, then the users array can be cleared
      if (!params.offset) {
        dispatch(clearAdminUsers());
      }
      dispatch(setLoading());

      const { data } = await dispatch(get(`/admin/users?${url}`));

      dispatch(!params.offset ? setAdminUsersSuccess(data) : getAdminUsersNextPageSuccess(data));
      dispatch(clearLoading());
    } catch (error) {
      dispatch(setAdminUsersError(true));
      dispatch(clearLoading());
    }
  };
};
